import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { Menu, Power, X, ArrowLeft } from "lucide-react";
import api from "../../api";
import useSeo from "../../hooks/useSeo";

const adminLinks = [
  { label: "Dashboard", to: "/admin/dashboard" },
  { label: "Manage Result", to: "/admin/result" },
  { label: "Previous Result", to: "/admin/previous" },
  { label: "Bulk Import", to: "/admin/bulk-import" },
  { label: "Change Password", to: "/admin/password" },
];

const AdminLayout = ({ title, children, showBack }) => {
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();
  useSeo(`${title} | Admin`, "", { robots: "noindex, nofollow" });

  const logout = () => {
    api.logout();
    navigate("/admin");
  };

  return (
    <div className="min-h-screen bg-[#f4f5f7] flex flex-col">
      {/* top bar */}
      <div className="w-full bg-[#eef1f4] border-b border-[#dfe3e8] flex items-stretch">
        <button
          onClick={() => setOpen(true)}
          className="px-4 flex items-center hover:bg-[#e2e6ea] transition-colors"
          aria-label="Menu"
        >
          <Menu className="w-7 h-7 text-[#5b6b7b]" strokeWidth={2.5} />
        </button>
        <h1 className="flex-1 flex items-center text-2xl font-medium text-[#5b6b7b]">
          {title}
        </h1>
        <button
          onClick={logout}
          className="bg-[#e5342a] hover:bg-[#c92c23] text-white px-5 flex items-center gap-2 font-medium transition-colors"
        >
          <Power className="w-5 h-5" />
          Log Out
        </button>
      </div>

      <main className="flex-1 w-full max-w-3xl mx-auto px-4 py-6">
        {showBack && (
          <button
            onClick={() => navigate("/admin/dashboard")}
            className="inline-flex items-center gap-1 text-sm text-[#2f5d84] mb-4 hover:underline"
          >
            <ArrowLeft className="w-4 h-4" /> Back to Dashboard
          </button>
        )}
        {children}
      </main>

      {/* drawer */}
      {open && (
        <div className="fixed inset-0 z-50">
          <div className="absolute inset-0 bg-black/50" onClick={() => setOpen(false)} />
          <div className="absolute top-0 left-0 h-full w-72 bg-white shadow-xl flex flex-col">
            <div className="flex items-center justify-between px-4 py-4 bg-[#eef1f4]">
              <span className="font-bold text-[#5b6b7b]">Admin Menu</span>
              <button onClick={() => setOpen(false)} aria-label="Close">
                <X className="w-6 h-6 text-[#5b6b7b]" />
              </button>
            </div>
            <nav className="flex-1 overflow-y-auto py-2">
              {adminLinks.map((l) => (
                <button
                  key={l.to}
                  onClick={() => {
                    setOpen(false);
                    navigate(l.to);
                  }}
                  className="w-full text-left px-5 py-3 text-[15px] text-[#374151] hover:bg-[#f1f5f9] border-b border-gray-100 transition-colors"
                >
                  {l.label}
                </button>
              ))}
              <Link
                to="/"
                onClick={() => setOpen(false)}
                className="block px-5 py-3 text-[15px] text-[#2f5d84] hover:bg-[#f1f5f9]"
              >
                View Website
              </Link>
            </nav>
          </div>
        </div>
      )}
    </div>
  );
};

export default AdminLayout;
